module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.usuarioPermissaoEspelhoRelatorio()) ? _c('v-btn', {
    staticClass: "text-xs-right, botaoGerarPDF",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.toRelatorioPDF
    }
  }, [_vm._v("Gerar PDF do Relatório")]) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Relatório Técnico de Extensão ' + this.relatorioExtensao.ordem
    }
  }), _vm._v(" "), _c('v-card-text', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.tituloAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": this.relatorioExtensao.tituloAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.nomeCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": this.relatorioExtensao.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.numeroAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": this.relatorioExtensao.numeroAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.tipoAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": this.relatorioExtensao.tipoAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.unidade !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Unidade",
      "value": this.relatorioExtensao.unidade
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Unidade",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.emailCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "E-mail do coordenador",
      "value": this.relatorioExtensao.emailCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "E-mail do coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.liberacaoCargaHorariaCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Liberação de carga horária do coordenador",
      "value": this.relatorioExtensao.liberacaoCargaHorariaCoordenador == true ? 'Sim' : 'Não'
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Liberação de carga horária do coordenador",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.cargaHorariaCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Carga horária",
      "value": this.relatorioExtensao.cargaHorariaCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Carga horária",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), ((_vm.projeto.classificacaoSecundaria.id === 39729 || _vm.projeto.classificacaoSecundaria.id === 44194 || _vm.projeto.classificacaoSecundaria.id === 44195 || _vm.projeto.classificacaoSecundaria.id === 39730) && _vm.relatorioExtensao.tipoRelatorioTecnicoItem === 3) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.mudancaDatasAcao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Houve mudança nas datas de início e/ou de conclusão da ação de extensão?",
      "value": this.relatorioExtensao.mudancaDatasAcao === 'S' ? 'Sim' : 'Não'
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Houve mudança nas datas de início e/ou de conclusão da ação de extensão?",
      "value": "-"
    }
  })], 1), _vm._v(" "), (this.relatorioExtensao.mudancaDatasAcao === 'S') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.justificativaMudancaDatasAcao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Justificativa",
      "value": this.relatorioExtensao.justificativaMudancaDatasAcao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Justificativa",
      "value": "-"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("Período a que se refere o relatório")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Início:",
      "value": _vm.relatorioExtensao.dtInicialFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Fim:",
      "value": _vm.relatorioExtensao.dtFinalFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Situação do relatório",
      "value": _vm.getSituacaoRelatorio(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem)
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Situação do relatório",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3 || _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4)) ? _c('div', [(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3) ? _c('div', [_c('br'), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.dtAprovacaoRelatorio !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de aprovação do relatório pela Câmara de Extensão",
      "value": _vm.relatorioExtensao.dtAprovacaoFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de aprovação do relatório pela Câmara de Extensão",
      "value": "-"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4) ? _c('div', [_c('br'), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.dtReprovacaoRelatorio !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de reprovação do relatório pela Câmara de Extensão",
      "value": _vm.relatorioExtensao.dtReprovacaoFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de reprovação do relatório pela Câmara de Extensão",
      "value": "-"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.processo !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Processo",
      "value": _vm.relatorioExtensao.processo
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Processo",
      "value": "-"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "item"
  }, [(_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 1) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 2) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 3) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.relatorioExtensao.tipoRelatorioTecnicoItem) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "-"
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 2) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "Nova data de conclusão da ação de extensão:",
      "value": _vm.relatorioExtensao.dtNovaConclusaoFormatada
    }
  }), _vm._v(" "), _c('br')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioForaPrazo === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "Apresentar justificativa para envio do relatório fora do prazo:",
      "align": "justify",
      "value": _vm.relatorioExtensao.justificativaForaPrazo || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioForaPrazo === true) ? _c('div', [_c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "1) A metodologia foi alterada para alcançar os objetivos da proposta inicial?",
      "align": "justify",
      "value": _vm.relatorioExtensao.opcao5 === null ? '-' : _vm.relatorioExtensao.opcao5 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao5 === 'S') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "Apresente sucintamente as alterações implementadas:",
      "value": _vm.relatorioExtensao.texto1 !== null && _vm.relatorioExtensao.texto1 !== '' ? _vm.relatorioExtensao.texto1 : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "2) Local de execução da ação:",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto2 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.relatorioExtensao.texto3 != null && _vm.relatorioExtensao.texto3.length !== 0 && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== 1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "3) Informar o quantitativo total de indivíduos beneficiados no período deste relatório",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto3 || '-'
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("3) Informar o quantitativo total de indivíduos beneficiados no período deste\n                    relatório")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "3.1 - Público-alvo direto (público concretamente registrado):",
      "value": _vm.relatorioExtensao.publicoAlvoDireto || '-'
    }
  }), _vm._v(" "), _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "3.2 - Público-alvo indireto (estimativa de público atingido indiretamente):",
      "value": _vm.relatorioExtensao.publicoAlvoIndireto || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("4) Atividades e resultados")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.relatorioExtensao.listaRelatorioAtividade), function(item, i) {
    return _c('v-col', {
      key: i
    }, [_c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "label": "Nome e descrição sucinta da atividade",
        "value": item.descricao
      }
    }), _vm._v(" "), (item.detalhamento !== null && item.detalhamento !== '') ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "value": item.detalhamento
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "label": "Principal objetivo específico ao qual esta atividade está vinculada",
        "value": item.objetivoEspecifico !== null && item.objetivoEspecifico !== '' ? item.objetivoEspecifico : '-'
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [(item.situacaoAtividade !== null) ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Situação",
        "value": _vm.situacaoAtividade.format(item.situacaoAtividade.item)
      }
    }) : _vm._e(), _vm._v(" "), (item.situacaoAtividade === null) ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Situação",
        "value": "-"
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md5": "",
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Início efetivo",
        "value": _vm.dates.format(item.dtInicioEfetivo)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md1": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md5": "",
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Conclusão efetiva",
        "value": _vm.dates.format(item.dtFimEfetivo)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md1": ""
      }
    })], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "label": "Resultados",
        "value": item.resultados !== null && item.resultados !== '' ? item.resultados : '-'
      }
    })], 1)], 1)], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "5) Discutir de forma geral a relevância das atividades, seu mérito extensionista, impacto, abrangência social, interdisciplinaridade e visibilidade:",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto4 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "6) Descrever de que maneira a ação de extensão contribuiu para a formação do aluno de graduação integrante da equipe:",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto5 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("7) Relacionar os fatores que interferiram na execução da ação")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "7.1 - Positivos:",
      "value": _vm.relatorioExtensao.texto6 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "7.2 - Negativos:",
      "value": _vm.relatorioExtensao.texto7 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("8) Equipe.")])])], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "tabela",
    attrs: {
      "headers": _vm.headersIntegrantes,
      "items": _vm.relatorioExtensao.listaRelatorioParticipante,
      "items-per-page": -1,
      "hide-default-footer": "",
      "header-props": {
        sortIcon: null
      }
    },
    scopedSlots: _vm._u([{
      key: "item.assessor",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.formatAssessor.format(props.item.assessor,
          props.item.funcao.item)))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("9) Formas de apoio")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "9.1 - A ação de extensão recebeu apoio da ProEx?",
      "value": _vm.relatorioExtensao.opcao1 === null ? '-' : _vm.relatorioExtensao.opcao1 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao1 === 'S') ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorioSubitem"
  }, [_vm._v("Especifique a(s) forma(s) de apoio:")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Bolsa")])]
      },
      proxy: true
    }], null, false, 3329032051),
    model: {
      value: (_vm.relatorioExtensao.boolean1_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_1", $$v)
      },
      expression: "relatorioExtensao.boolean1_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Passagem")])]
      },
      proxy: true
    }], null, false, 2386299455),
    model: {
      value: (_vm.relatorioExtensao.boolean1_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_2", $$v)
      },
      expression: "relatorioExtensao.boolean1_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Diária")])]
      },
      proxy: true
    }], null, false, 3814078326),
    model: {
      value: (_vm.relatorioExtensao.boolean1_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_3", $$v)
      },
      expression: "relatorioExtensao.boolean1_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material de consumo")])]
      },
      proxy: true
    }], null, false, 1871919084),
    model: {
      value: (_vm.relatorioExtensao.boolean1_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_4", $$v)
      },
      expression: "relatorioExtensao.boolean1_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material permanente")])]
      },
      proxy: true
    }], null, false, 961207380),
    model: {
      value: (_vm.relatorioExtensao.boolean1_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_5", $$v)
      },
      expression: "relatorioExtensao.boolean1_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Recurso financeiro")])]
      },
      proxy: true
    }], null, false, 1798790707),
    model: {
      value: (_vm.relatorioExtensao.boolean1_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_6", $$v)
      },
      expression: "relatorioExtensao.boolean1_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Espaço físico")])]
      },
      proxy: true
    }], null, false, 3522186450),
    model: {
      value: (_vm.relatorioExtensao.boolean1_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_7", $$v)
      },
      expression: "relatorioExtensao.boolean1_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Divulgação")])]
      },
      proxy: true
    }], null, false, 2707204751),
    model: {
      value: (_vm.relatorioExtensao.boolean1_8),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_8", $$v)
      },
      expression: "relatorioExtensao.boolean1_8"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Transporte")])]
      },
      proxy: true
    }], null, false, 1984826566),
    model: {
      value: (_vm.relatorioExtensao.boolean1_9),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_9", $$v)
      },
      expression: "relatorioExtensao.boolean1_9"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean1_10),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_10", $$v)
      },
      expression: "relatorioExtensao.boolean1_10"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Especifique:",
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto14),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto14", $$v)
      },
      expression: "relatorioExtensao.texto14"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "9.2 - A ação de extensão recebeu apoio de outras instituições e/ou órgãos de fomento nacionais, internacionais ou estrangeiros?",
      "value": _vm.relatorioExtensao.opcao2 === null ? '-' : _vm.relatorioExtensao.opcao2 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao2 === 'S') ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorioSubitem"
  }, [_vm._v("Especifique a(s) forma(s) de apoio:")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Bolsa")])]
      },
      proxy: true
    }], null, false, 3329032051),
    model: {
      value: (_vm.relatorioExtensao.boolean2_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_1", $$v)
      },
      expression: "relatorioExtensao.boolean2_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Passagem")])]
      },
      proxy: true
    }], null, false, 2386299455),
    model: {
      value: (_vm.relatorioExtensao.boolean2_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_2", $$v)
      },
      expression: "relatorioExtensao.boolean2_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Diária")])]
      },
      proxy: true
    }], null, false, 3814078326),
    model: {
      value: (_vm.relatorioExtensao.boolean2_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_3", $$v)
      },
      expression: "relatorioExtensao.boolean2_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material de consumo")])]
      },
      proxy: true
    }], null, false, 1871919084),
    model: {
      value: (_vm.relatorioExtensao.boolean2_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_4", $$v)
      },
      expression: "relatorioExtensao.boolean2_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material permanente")])]
      },
      proxy: true
    }], null, false, 961207380),
    model: {
      value: (_vm.relatorioExtensao.boolean2_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_5", $$v)
      },
      expression: "relatorioExtensao.boolean2_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Recurso financeiro")])]
      },
      proxy: true
    }], null, false, 1798790707),
    model: {
      value: (_vm.relatorioExtensao.boolean2_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_6", $$v)
      },
      expression: "relatorioExtensao.boolean2_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Espaço físico")])]
      },
      proxy: true
    }], null, false, 3522186450),
    model: {
      value: (_vm.relatorioExtensao.boolean2_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_7", $$v)
      },
      expression: "relatorioExtensao.boolean2_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Divulgação")])]
      },
      proxy: true
    }], null, false, 2707204751),
    model: {
      value: (_vm.relatorioExtensao.boolean2_8),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_8", $$v)
      },
      expression: "relatorioExtensao.boolean2_8"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Transporte")])]
      },
      proxy: true
    }], null, false, 1984826566),
    model: {
      value: (_vm.relatorioExtensao.boolean2_9),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_9", $$v)
      },
      expression: "relatorioExtensao.boolean2_9"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean2_10),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_10", $$v)
      },
      expression: "relatorioExtensao.boolean2_10"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Especifique:",
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto15),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto15", $$v)
      },
      expression: "relatorioExtensao.texto15"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) && (_vm.relatorioExtensao.opcao2 === 'N' || _vm.relatorioExtensao.boolean2_6 === false)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                      9.3 - Os recursos financeiros indicados no item 9.1 foram executados por:\n                    ")]) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'N' || _vm.relatorioExtensao.boolean1_6 === false) && (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                      9.3 - Os recursos financeiros indicados no item 9.2 foram executados por:\n                    ")]) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) && (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                      9.3 - Os recursos financeiros indicados nos itens 9.1 e 9.2 foram executados por:\n                    ")]) : _vm._e()])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorioExtensao.boolean3_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_1", $$v)
      },
      expression: "relatorioExtensao.boolean3_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_1", $$v)
      },
      expression: "relatorioExtensao.valor3_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CNPq")])]
      },
      proxy: true
    }], null, false, 1739938252),
    model: {
      value: (_vm.relatorioExtensao.boolean3_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_2", $$v)
      },
      expression: "relatorioExtensao.boolean3_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_2", $$v)
      },
      expression: "relatorioExtensao.valor3_2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CAPES")])]
      },
      proxy: true
    }], null, false, 3158995236),
    model: {
      value: (_vm.relatorioExtensao.boolean3_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_3", $$v)
      },
      expression: "relatorioExtensao.boolean3_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_3", $$v)
      },
      expression: "relatorioExtensao.valor3_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FAPES")])]
      },
      proxy: true
    }], null, false, 4155422625),
    model: {
      value: (_vm.relatorioExtensao.boolean3_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_4", $$v)
      },
      expression: "relatorioExtensao.boolean3_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_4", $$v)
      },
      expression: "relatorioExtensao.valor3_4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorioExtensao.boolean3_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_5", $$v)
      },
      expression: "relatorioExtensao.boolean3_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_5", $$v)
      },
      expression: "relatorioExtensao.valor3_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorioExtensao.boolean3_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_6", $$v)
      },
      expression: "relatorioExtensao.boolean3_6"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_6", $$v)
      },
      expression: "relatorioExtensao.valor3_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean3_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_7", $$v)
      },
      expression: "relatorioExtensao.boolean3_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Especifique:",
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto16),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto16", $$v)
      },
      expression: "relatorioExtensao.texto16"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_7", $$v)
      },
      expression: "relatorioExtensao.valor3_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "10) Houve cobrança de taxa de inscrição, participação, visitação ou similar?",
      "value": _vm.relatorioExtensao.opcao4 === null ? '-' : _vm.relatorioExtensao.opcao4 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao4 === 'S') ? _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("Os recursos financeiros foram administrados por:")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorioExtensao.boolean4_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_1", $$v)
      },
      expression: "relatorioExtensao.boolean4_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_1", $$v)
      },
      expression: "relatorioExtensao.valor4_1"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorioExtensao.boolean4_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_2", $$v)
      },
      expression: "relatorioExtensao.boolean4_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_2", $$v)
      },
      expression: "relatorioExtensao.valor4_2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorioExtensao.boolean4_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_3", $$v)
      },
      expression: "relatorioExtensao.boolean4_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_3", $$v)
      },
      expression: "relatorioExtensao.valor4_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean4_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_4", $$v)
      },
      expression: "relatorioExtensao.boolean4_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Especifique:",
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto17),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto17", $$v)
      },
      expression: "relatorioExtensao.texto17"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_4", $$v)
      },
      expression: "relatorioExtensao.valor4_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("11) Informar as parcerias/colaborações: contatos nacionais e internacionais\n                    efetivamente ocorridos em função da atividade, como convênios, acordos de colaboração e\n                    outros.")])])], 1), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioParceria.length !== 0) ? _c('v-data-table', {
    staticClass: "tabela",
    attrs: {
      "headers": _vm.headersParcerias,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.relatorioExtensao.listaRelatorioParceria,
      "items-per-page": -1,
      "hide-default-footer": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioParceria.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                    Nenhuma parceria/colaboração foi informada\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("12) Informar produtos de extensão")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.1 - Trabalhos publicados e/ou aceitos para publicação no período, tais como livros, capítulos de livros, artigos em periódicos nacionais e internacionais, resumos em congressos, reuniões científicas e semelhantes. Indicar claramente entre os autores dos trabalhos, quando for o caso, os bolsistas e os voluntários:",
      "value": _vm.relatorioExtensao.texto9 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.2 - Patente ou registro de invenção ou técnica (informar o título, se a patente é nacional, internacional ou “joint ventures” e outros dados que julgar adequados):",
      "value": _vm.relatorioExtensao.texto10 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.3 - Outras atividades extensionistas, científicas ou administrativas que julgar pertinentes no período: organização ou participação em eventos científicos, consultorias, assessorias a órgãos de fomento, etc:",
      "value": _vm.relatorioExtensao.texto11 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.4 - Premiações obtidas em função do desenvolvimento da atividade de extensão (título do prêmio, quem outorgou, data, local); honrarias acadêmicas:",
      "value": _vm.relatorioExtensao.texto12 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.5 - Links para matérias jornalísticas sobre a ação:",
      "value": _vm.relatorioExtensao.texto13 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("13) Anexar materiais que comprovem a execução da ação de extensão, como:\n                    fotografias, livros, cartazes, panfletos, folders, manuais e outros:")])])], 1), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioArquivo.length !== 0) ? _c('v-data-table', {
    staticClass: "tabela",
    attrs: {
      "headers": _vm.headers0,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.relatorioExtensao.listaRelatorioArquivo,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n                  Total de " + _vm._s(_vm.relatorioExtensao.listaRelatorioArquivo.length) + " arquivos\n                ")]
      }
    }], null, false, 1847614262)
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioArquivo.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                    Nenhum material foi anexado\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.coordenadorAdministradorSubmeteremAprovacao() && (_vm.relatorioHabilitadoAcaoRegistroTardio() === false)) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toSubmeter()
      }
    }
  }, [_vm._v("Submeter para aprovação")]) : _vm._e(), _vm._v(" "), (_vm.coordenadorAssessorPodemValidar() || _vm.administradorPodeValidar()) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.verificarPendenciasRelatorio()
      }
    }
  }, [_vm._v("Verificar pendências")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.coordenadorAssessorPodemEditar() || _vm.administradorPodeEditar()) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toEditar
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cfdca44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/relatorio/relatorio-tecnico.vue
// module id = 771
// module chunks = 0